/*
  Media queries config
  Usage example:
  @media ${media.tablet} {
      <properties>
   }
*/

const breakpoints: { [key: string]: number } = {
    mobile: 361,
    small: 640,
    medium: 1168,
    large: 1536,
    xlarge: 1920,
};

export const orientation = {
    portrait: `(orientation: portrait)`,
    landscape: `(orientation: landscape)`,
};

export function isMobileSizeScreen() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.innerWidth < breakpoints.small;
}

export function isTabletSizeScreen() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.innerWidth < breakpoints.medium;
}

export function isLandscapeOrientation() {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return ['landscape-primary', 'landscape-secondary'].includes(window.screen.orientation?.type);
}

export default Object.keys(breakpoints).reduce((acc: { [key: string]: string }, cur: string) => {
    acc[cur] = `(min-width: ${breakpoints[cur]}px)`;
    return acc;
}, {});

export const maxWidth = Object.keys(breakpoints).reduce(
    (acc: { [key: string]: string }, cur: string) => {
        acc[cur] = `(max-width: ${breakpoints[cur]}px)`;
        return acc;
    },
    {}
);
